<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import Loader from "@/router/views_mobagile/components/loader.vue";
import api from "@/axios";
import exportFromJSON from "export-from-json";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Relatórios Administrativos",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
  },
  data() {
    return {
      empresaData: null,
      updating: false,
      periodo: null,
      title: "Relatórios Administrativos",
      items: [
        {
          text: "Administrativo",
          href: "/",
        },
        {
          text: "Relatórios Administrativos",
          active: true,
        },
      ],
    };
  },

  mounted() {
    let dataAtu = new Date()
    const anoAtu = dataAtu.getFullYear()
    // const mesAtu = ("0" + (dataAtu.getMonth() + 1)).slice(-2)
    const mesAtu = ("0" + (dataAtu.getMonth())).slice(-2)
    // console.log(dataAtu.getFullYear())
    // console.log(dataAtu.getMonth())
    // console.log(mesAtu)
    // console.log(anoAtu)
    this.periodo = anoAtu + '-' + mesAtu
  },

  methods: {

    relEFDFiscal(){
      console.log('relEFDFiscal')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdfisc`, {
        params: {
          periodo: this.periodo
        }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data[1]
        const fileName = "EFD_Fiscal_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relEFDPisCofins(){
      console.log('relEFDPisCofins')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true
      api.get(`${getBaseUrl()}api/efdpiscof`).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.empresaData = res.data[0]
        const data = res.data
        const fileName = "EFD_PisCofins_" + this.empresaData.fantasia + '_' + this.periodo;
        const exportType = exportFromJSON.types.txt;
        if (data) exportFromJSON({ data, fileName, exportType });
        this.updating = false
      });
    },

    relResultados(){
      console.log('relResultados')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      this.updating = true

      api.get(`${getBaseUrl()}api/relresults`, {
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_resultados_001.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },


    mudouPeriodo(){
      console.log('mudouPeriodo')
      console.log(this.periodo)
      console.log(typeof this.periodo)
      // this.carregarDados()
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="!updating">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row mb-2">

              <div class="col-sm-1">
                <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22" >
                  <i class="mdi mdi-filter"></i>
                </span>
              </div>

              <div class="col-sm-2">
                <div class="text-muted">
                  <h5>Selecione o período para emissão</h5>

                </div>
              </div>

              <div class="col-sm-2 text-start">

                <input
                    id="periodo"
                    v-model="periodo"
                    type="month"
                    @change="mudouPeriodo"
                    class="form-control"
                    style="max-width: 200px;"
                    placeholder="Início"/>

              </div>

            </div>

          </div>
        </div>
      </div>
    </div>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>



    <div class="row" v-if="!updating">

      <div class="col-xl-4 col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="avatar-md me-4">
                <span
                    class="avatar-title rounded-circle bg-light text-danger font-size-16"
                >
                  <img :src="require('@/assets/images/companies/img-4.png')" alt height="30" />
                </span>
              </div>

              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <a href="javascript: void(0);"
                     @click="relEFDFiscal"
                     class="text-dark">
                    EFD Fiscal
                  </a>
                </h5>
                <p class="text-muted mb-4">
                  Arquivo com Escrituração Fiscal Digital
                </p>
                <div class="avatar-group">
                  <div class="avatar-group-item">
                    <a href="javascript: void(0);"
                       @click="relEFDFiscal"
                       class="d-inline-block">
                      <div class="avatar-xs">
                        <span class="avatar-title rounded-circle">ADM</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <span class="badge bg-success">
                  Disponível
                </span>
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Due Date"
              >
                <i class="bx bx-calendar me-1"></i>
                {{ formatDateTime(Date.now()) }}
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Comments"
              >
                <i class="bx bx-comment-dots me-1"></i>
                0
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div class="col-xl-4 col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="avatar-md me-4">
                <span
                    class="avatar-title rounded-circle bg-light text-danger font-size-16"
                >
                  <img :src="require('@/assets/images/companies/img-4.png')" alt height="30" />
                </span>
              </div>

              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <a href="javascript: void(0);"
                     @click="relEFDPisCofins"
                     class="text-dark">
                    EFD PIS e COFINS
                  </a>
                </h5>
                <p class="text-muted mb-4">
                  Arquivo com Escrituração Fiscal Digital do PIS e o COFINS
                </p>
                <div class="avatar-group">
                  <div class="avatar-group-item">
                    <a href="javascript: void(0);"
                       @click="relEFDPisCofins"
                       class="d-inline-block">
                      <div class="avatar-xs">
                        <span class="avatar-title rounded-circle">ADM</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <span class="badge bg-success">
                  Disponível
                </span>
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Due Date"
              >
                <i class="bx bx-calendar me-1"></i>
                {{ formatDateTime(Date.now()) }}
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Comments"
              >
                <i class="bx bx-comment-dots me-1"></i>
                0
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div class="col-xl-4 col-sm-6">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="avatar-md me-4">
                <span
                    class="avatar-title rounded-circle bg-light text-danger font-size-16"
                >
                  <img :src="require('@/assets/images/companies/img-5.png')" alt height="30" />
                </span>
              </div>

              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">
                  <a href="javascript: void(0);"
                     @click="relResultados"
                     class="text-dark">
                    Relatório de Resultado
                  </a>
                </h5>
                <p class="text-muted mb-4">
                  Apuração de Entradas e Saídas
                </p>
                <div class="avatar-group">
                  <div class="avatar-group-item">
                    <a href="javascript: void(0);"
                       @click="relResultados"
                       class="d-inline-block">
                      <div class="avatar-xs">
                        <span class="avatar-title rounded-circle">ADM</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-4 py-3 border-top">
            <ul class="list-inline mb-0">
              <li class="list-inline-item me-3">
                <span class="badge bg-success">
                  Disponível
                </span>
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Due Date"
              >
                <i class="bx bx-calendar me-1"></i>
                {{ formatDateTime(Date.now()) }}
              </li>
              <li
                  v-b-tooltip.hover.top
                  class="list-inline-item me-3"
                  title="Comments"
              >
                <i class="bx bx-comment-dots me-1"></i>
                0
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>



    <div class="row">
      <div class="col-lg-12">
        <ul
          class="pagination pagination-rounded justify-content-center mt-2 mb-5"
        >
          <li class="page-item disabled">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">1</a>
          </li>
          <li class="page-item active">
            <a href="#" class="page-link">2</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">3</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">4</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">5</a>
          </li>
          <li class="page-item">
            <a href="#" class="page-link">
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>

  </Layout>
</template>
